<script lang="ts">
    import { onMount } from 'svelte';

    import AdvCookieNotice from '../components/AdvCookieNotice.svelte';
    import CardEndHeadArea from '../components/CardEndHeadArea.svelte';
    import CardEndLoginModule from '../components/CardEndLoginModule.svelte';
    import QuickDownload from '../components/QuickDownload.svelte';
    import { CLOSE_ICON } from '../constants/imgList';
    import { EXPOSE_SUCCESS_SW } from '../enums/track';
    import {
        bottomButtonHeight,
        cookieHeight,
        regPageExposeAt,
        visible
    } from '../store/index';
    import { checkIsLogin } from '../utils/passport';
    import { trackEvent } from '../utils/track';

    import { reportP4Direct } from '@/utils/fmpTrack';
    import { trackEventModuleSw } from '@/utils/techTrack';

    const BOTTOM_PADDING_OFFSET = 96;
    // 留白 = cookieHeight + 2rem（吸底区：上 0.4 含 address 间距 + 按钮 1.2 + 下 0.4）

    $: totalPadding = Math.max(
        0,
        $cookieHeight + $bottomButtonHeight - BOTTOM_PADDING_OFFSET
    );
    $: paddingBottom = totalPadding > 0 ? `${totalPadding}px` : '0';

    onMount(async () => {
        regPageExposeAt.set(Date.now());
        await checkIsLogin();
        trackEvent(EXPOSE_SUCCESS_SW);
        reportP4Direct();
        trackEventModuleSw('main_page_sw');
    });
</script>

<div
    class="card-page"
    style={`transition: padding-bottom 0.3s ease; padding-bottom: ${paddingBottom};`}
>
    {#if $visible}
        <QuickDownload
            useEndLogo={true}
            bgColor="#FFFFFF"
            color="#0C0C0D"
            jumpColor="#FF5F14"
            closeIcon={CLOSE_ICON}
        />
    {/if}
    <CardEndHeadArea />
    <CardEndLoginModule />
    <AdvCookieNotice />
</div>

<style lang="scss">
    :global(body) {
        background: #ffffff;
    }

    .card-page {
        margin: auto;
        margin-top: 0;
        width: 7.5rem;
        min-height: 100vh;
        position: relative;
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch;
        font-family: DiDiSans-Pro-Regular;
        user-select: none;
        background-color: #1c0b00;
        padding: 0;
        box-sizing: border-box;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        letter-spacing: 0;
        transition: padding-bottom 0.3s ease;
    }
</style>
